<template>
  <section>
    <div v-if="user.firstName || user.lastName" class="user-info">
      <img
        src="@/assets/images/account-icon.svg"
        alt=""
        width="16"
        height="16"
      />
      <p>{{ user.firstName }} {{ user.lastName }}</p>
    </div>

    <div v-if="user.address" class="address user-info">
      <img src="@/assets/user-account/home.svg" width="24" height="24" alt="" />
      <p v-thtml="formatAddress" />
    </div>

    <div v-if="user.telephone" class="user-info telephone">
      <img
        src="@/assets/images/mobile-icon.svg"
        width="14"
        height="23"
        alt=""
      />
      <p>{{ user.telephone }}</p>
    </div>

    <div v-if="user.email" class="user-info">
      <img src="@/assets/images/mail.svg" width="18" height="13" alt="" />
      <p>{{ user.email }}</p>
    </div>

    <div
      v-if="
        (user.pitchType.requirePartyNames && user.namesOfAllPartyMembers) ||
        user.groupName
      "
      class="user-info group"
    >
      <img src="@/assets/images/group.svg" width="18" height="19" alt="" />
      <span>
        <translate
          v-if="user.pitchType.requirePartyNames && user.namesOfAllPartyMembers"
          tag="p"
          :tt="{
            namesOfAllPartyMembers: user.namesOfAllPartyMembers,
          }"
        >
          Names of all party members: {namesOfAllPartyMembers}
        </translate>
        <translate
          v-if="user.groupName"
          tag="p"
          class="groupname"
          :tt="{ groupName: user.groupName }"
        >
          Group name: {groupName}
        </translate>
      </span>
    </div>

    <div
      v-if="user.pitchType.requireCarRegistration && user.carRegistrationNumber"
      class="user-info"
    >
      <img
        src="@/assets/user-account/car-front.svg"
        width="24"
        height="auto"
        class="vehicle"
        alt=""
      />
      <translate
        tag="p"
        :tt="{
          carRegistrationNumber: user.carRegistrationNumber,
        }"
      >
        Vehicle registration number: {carRegistrationNumber}
      </translate>
    </div>

    <translate
      v-if="user.estimatedTimeOfArrival"
      tag="p"
      :tt="{
        estimatedTimeOfArrival: user.estimatedTimeOfArrival,
      }"
    >
      Estimated time of arrival: {estimatedTimeOfArrival}
    </translate>

    <translate
      v-if="user.specialRequests"
      tag="p"
      :tt="{
        bookingSpecialRequests: user.specialRequests,
      }"
    >
      Special requests: {bookingSpecialRequests}
    </translate>
  </section>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import type { userBookingPitchTypeSchema } from '../../apps/user-bookings/schemas'

interface UserDetails {
  address: string
  city: string
  county: string
  postcode: string
  country: string
  firstName: string
  lastName: string
  telephone: string
  email: string
  groupName: string
  specialRequests: string
  carRegistrationNumber: string
  namesOfAllPartyMembers: string
  pitchType: userBookingPitchTypeSchema
}

@Component
class UserDetailsComponent extends Vue {
  @Prop({ required: true })
  user: UserDetails

  get formatAddress(): string {
    return [
      this.user.address,
      this.user.city,
      this.user.county,
      this.user.postcode,
      this.user.country,
    ]
      .filter((el) => el !== '')
      .join('<br>')
  }
}

export default toNative(UserDetailsComponent)
</script>
<style scoped>
.user-info {
  display: grid;
  grid-template-columns: 1.4em 1fr;
  place-items: start start;
  gap: 0.7em;
  margin-bottom: 0.65em;
}

.user-info.telephone {
  place-items: center start;
}

.user-info img {
  place-self: center center;
  filter: brightness(0) opacity(0.35);
}

.party-names {
  white-space: pre-line;
}

.user-info img.vehicle,
.user-info.group img,
.user-info.party-details img,
.user-info.address img {
  place-self: start center;
}

.vehicle {
  margin-top: 0.1em;
}

.numberplate {
  border-radius: 0.3em;
  font-family: helvetica, arial, sans-serif;
  font-weight: 600;
  padding: 2px 0.4em;
  text-transform: uppercase;
  border: 1px solid #dedede;
  display: inline-block;
}

.unit-type {
  display: block;
}

p.groupname {
  margin: 0;
}

.personal-details p > span:not(.numberplate) {
  margin-bottom: 0.3em;
}
</style>
